import { ErrorBase } from '@core/models/error.model';

export class SsoError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export class SsoErrorModel {
  handle(error: ErrorBase) {
    throw new SsoError(error.message ?? error.desc?.message ?? 'Lỗi xác thực SSO');
  }
}
